<template>
  <div id="app">
    <div class="wrapper">
      <router-view v-slot="{ Component }">
        <transition mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
      <Toast />
    </div>
  </div>
</template>

<script setup>
import {  onMounted, getCurrentInstance } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

const store = useStore();
const route = useRoute();
const router = useRouter();
const instance = getCurrentInstance();

//const language = computed(() => store.getters.language);

const setInitialLanguage = () => {
  const validLocales = ['en', 'de', 'fr', 'it'];
  const normalizeLocaleCode = (value, fallback = process.env.VUE_APP_I18N_LOCALE || 'de') => {
    if (typeof value === 'string') {
      return validLocales.includes(value) ? value : fallback;
    }

    if (value && typeof value === 'object') {
      const candidate = value.code || value.language || value.name;
      if (typeof candidate === 'string' && validLocales.includes(candidate)) {
        return candidate;
      }
    }

    return fallback;
  };

  const userLocale = store.getters.loggedUser?.language ?? store.getters.loggedUser?.settings?.locale;
  const storedLocale = window.localStorage.getItem("language");
  const localeCode = normalizeLocaleCode(userLocale, normalizeLocaleCode(storedLocale, process.env.VUE_APP_I18N_LOCALE || 'de'));

  window.localStorage.setItem("language", localeCode);
  store.commit("setLanguage", localeCode);

  const i18n = instance.proxy.$i18n;
  if (i18n) {
    i18n.locale = localeCode;
  }
};

const setDarkMode = () => {
  const savedDarkMode = window.localStorage.getItem("darkMode") === "true";

  store.commit("setIsDarkMode", savedDarkMode);

  document.documentElement.setAttribute(
    "data-theme",
    savedDarkMode ? "dark" : "light"
  );
};

onMounted(() => {
  setInitialLanguage();

  setDarkMode();

  document.addEventListener("keydown", (event) => {
    if (
      event.key &&
      event.key.toLowerCase() === "l" &&
      event.ctrlKey &&
      route.name !== "Lock"
    ) {
      event.preventDefault();
      router.push({
        name: "Lock",
      });
    }
  });
});
</script>

<style lang="scss"> 
.offer-table {
  .input--default {
    //margin-top: -19px !important; 
    height: 100% !important;
  }

  .select.select--default {
    //margin-bottom: -6px !important;
    height: 100% !important;
  }

  .vs__dropdown-toggle {
    position: initial !important;
  }

  .vs__selected-options {
    margin-left: -16px !important;
  }
}

.disabled-el {
  cursor: not-allowed !important;

  .input,
  input,
  .select,
  select,
  textarea,
  button {
    cursor: not-allowed !important;
  }

  .select {
    &::after {
      background: url("./assets/icons/default/disabled-chevron_down.svg") !important;
    }
  }

  button {
    background-color: #B9C2CD;
  }

  textarea::placeholder {
    color: #7F8FA480 !important;
  }
}

[data-theme="dark"] .disabled-el {
  button {
    background-color: #5a6675;
  }
}


.wrapper {
  overflow-y: hidden;
}
</style>
